import React from 'react'

function SelfieUploadImage() {
  return (
    <svg width='204px' height='134px' viewBox='0 0 204 134'>
      <defs>
        <linearGradient x1='100%' y1='50%' x2='-2.22044605e-14%' y2='50%' id='linearGradient-1'>
          <stop stopColor='#C918BF' offset='0%'></stop>
          <stop stopColor='#1475E8' offset='100%'></stop>
        </linearGradient>
      </defs>
      <g id='new-customer' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='new-customer---selfie' transform='translate(-618.000000, -480.000000)'>
          <g id='Group-4' transform='translate(427.000000, 352.000000)'>
            <g id='Group-3' transform='translate(0.000000, 52.000000)'>
              <g id='Group-2' transform='translate(191.000000, 76.000000)'>
                <g id='59505' opacity='0.200000003' fill='#000000' fillRule='nonzero'>
                  <path
                    d='M202.949839,113.958925 C202.755789,113.733549 202.46993,113.599993 202.169466,113.599993 L1.03139068,113.599993 C0.73092611,113.599993 0.447154019,113.731462 0.251017427,113.958925 C0.0548808356,114.1843 -0.0327546629,114.486888 0.0110630863,114.785302 C0.0402749191,114.973115 3.07413241,133.599993 26.6209562,133.599993 L176.5799,133.599993 C200.124637,133.599993 203.158495,114.973115 203.189793,114.785302 C203.231524,114.486888 203.143889,114.1843 202.949839,113.958925 Z M116.726941,127.07662 L86.4718286,127.07662 L86.4718286,120.119192 L116.726941,120.119192 L116.726941,127.07662 Z'
                    id='Shape'></path>
                  <path
                    d='M21.7806631,106.399994 L181.419325,106.399994 C183.727051,106.399994 185.599989,104.52724 185.599989,102.21974 L185.599989,4.18025355 C185.599989,1.87275359 183.727051,0 181.419325,0 L21.7806631,0 C19.4729365,0 17.599999,1.87275359 17.599999,4.18025355 L17.599999,102.21974 C17.599999,104.52724 19.4729365,106.399994 21.7806631,106.399994 Z M32.2323236,14.6308874 L170.967664,14.6308874 L170.967664,91.7691062 L32.2323236,91.7691062 L32.2323236,14.6308874 Z'
                    id='Shape'></path>
                </g>
                <circle
                  id='Oval'
                  fill='url(#linearGradient-1)'
                  cx='101.599994'
                  cy='7.19999957'
                  r='3.19999981'></circle>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default React.memo(SelfieUploadImage)
